import * as React from "react";

interface IProps {
	value: string;
	onClickHandler?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const TextPresenter: React.SFC<IProps> = (props) => {
	return (
		<span className={props.onClickHandler && "clickable-cell"} onClick={props.onClickHandler}>
			{props.value}
		</span>
	);
};
